import { render, staticRenderFns } from "./DailyStockValue.vue?vue&type=template&id=00a0315e&scoped=true&"
import script from "./DailyStockValue.vue?vue&type=script&lang=ts&"
export * from "./DailyStockValue.vue?vue&type=script&lang=ts&"
import style0 from "./DailyStockValue.vue?vue&type=style&index=0&id=00a0315e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a0315e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
